(function () {
  document.querySelectorAll('[data-contact-quote]').forEach(function (root) {
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-contact-mode]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-contact-panel]'));
    var guidedForm = root.querySelector('#ContactQuoteGuided');
    var steps = guidedForm ? Array.prototype.slice.call(guidedForm.querySelectorAll('[data-guided-step]')) : [];
    var currentStep = 0;

    function setMode(mode) {
      modes.forEach(function (button) {
        var active = button.dataset.contactMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.contactPanel !== mode; });
      var target = root.querySelector('[data-contact-panel="' + mode + '"]');
      if (target) target.focus({ preventScroll: true });
    }

    function renderStep() {
      steps.forEach(function (step, index) { step.hidden = index !== currentStep; });
      var count = guidedForm && guidedForm.querySelector('[data-step-count]');
      var bar = guidedForm && guidedForm.querySelector('[data-step-progress]');
      if (count) count.textContent = 'Étape ' + (currentStep + 1) + ' sur ' + steps.length;
      if (bar) bar.style.width = (((currentStep + 1) / Math.max(1, steps.length)) * 100) + '%';
    }

    modes.forEach(function (button) { button.addEventListener('click', function () { setMode(button.dataset.contactMode); }); });
    if (guidedForm) {
      guidedForm.addEventListener('click', function (event) {
        var next = event.target.closest('[data-step-next]');
        var previous = event.target.closest('[data-step-previous]');
        if (next) {
          var activeStep = steps[currentStep];
          var requiredChoiceGroup = activeStep.querySelector('[data-choice-group][data-required="true"]');
          if (requiredChoiceGroup) {
            var choiceInputs = Array.prototype.slice.call(requiredChoiceGroup.querySelectorAll('input'));
            var firstChoice = choiceInputs[0];
            if (firstChoice) {
              firstChoice.setCustomValidity(choiceInputs.some(function (input) { return input.checked; }) ? '' : 'Sélectionnez au moins une réponse.');
              if (!firstChoice.reportValidity()) return;
            }
          }
          var required = Array.prototype.slice.call(activeStep.querySelectorAll('[required]'));
          if (!required.every(function (field) { return field.reportValidity(); })) return;
          currentStep = Math.min(steps.length - 1, currentStep + 1);
          renderStep();
        }
        if (previous) {
          currentStep = Math.max(0, currentStep - 1);
          renderStep();
        }
      });
      renderStep();
    }
    if (window.location.hash === '#ContactQuoteGuided') {
      setMode('guided');
    } else if (window.location.hash === '#ContactQuoteSimple') {
      setMode('simple');
    } else if (root.querySelector('[data-guided-response]')) {
      setMode('guided');
    }
  });
})();
